import { AuthModalConfig } from 'libs/auth/useAuthProtected';

import GenerateAccessToken from './impl/GenerateAccessToken';
import { ApiOption } from './test-access-tokens.types';
import useDemoAccessToken from './useDemoAccessToken';

const GenerateDemoAccessToken: React.FC<{
  apiOptions: ApiOption[];
  authProtectedConfig?: AuthModalConfig;
}> = ({ apiOptions, authProtectedConfig }) => {
  const { token, isGenerating, removeToken, generateToken } =
    useDemoAccessToken();

  return (
    <GenerateAccessToken
      apiOptions={apiOptions}
      tokenName="Demo"
      generateButtonText="Generate token"
      onCloseModal={removeToken}
      onGenerate={generateToken}
      token={token}
      authProtectedConfig={authProtectedConfig}
      isGenerating={isGenerating}
    />
  );
};

export default GenerateDemoAccessToken;
